/* @flow */
import Reaction from 'entities/Reaction';
import Collection from 'lib/Collection';

export default class Reactions extends Collection<Reactions> {
  parse(response: Object) {
    return response.map(reaction => Reaction.fromJSON(reaction));
  }
}
